import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateContainerTypeGroupMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type CreateContainerTypeGroupMutation = { __typename?: 'Mutation', createContainerTypeGroup: { __typename?: 'ContainerTypeGroup', id: number, name: string, has_linked_stores: boolean, container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image_url?: string | null }> } };


export const CreateContainerTypeGroupDocument = gql`
    mutation createContainerTypeGroup($name: String!) {
  createContainerTypeGroup(name: $name) {
    id
    name
    has_linked_stores
    container_types {
      id
      name
      image_url
    }
  }
}
    `;
export type CreateContainerTypeGroupMutationFn = Apollo.MutationFunction<CreateContainerTypeGroupMutation, CreateContainerTypeGroupMutationVariables>;

/**
 * __useCreateContainerTypeGroupMutation__
 *
 * To run a mutation, you first call `useCreateContainerTypeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContainerTypeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContainerTypeGroupMutation, { data, loading, error }] = useCreateContainerTypeGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateContainerTypeGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateContainerTypeGroupMutation, CreateContainerTypeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContainerTypeGroupMutation, CreateContainerTypeGroupMutationVariables>(CreateContainerTypeGroupDocument, options);
      }
export type CreateContainerTypeGroupMutationHookResult = ReturnType<typeof useCreateContainerTypeGroupMutation>;
export type CreateContainerTypeGroupMutationResult = Apollo.MutationResult<CreateContainerTypeGroupMutation>;
export type CreateContainerTypeGroupMutationOptions = Apollo.BaseMutationOptions<CreateContainerTypeGroupMutation, CreateContainerTypeGroupMutationVariables>;